<template>
    <div class="room-content">
        <Navbar :appTitle="appTitle" />
        <Search ref="topSearch" class="search" placeholder="物品编号|物品名称" :isAdd="false" :isScreen="true" :isType="true"
            @onSearch="onSearch">
        </Search>
        <!--分页列表 -->
        <div class="listBox">
            <PageList ref="pageList" :checkedShow="false" :columns="columns" :minLen="4" :listUrl="listUrl"
                :usedGetMethods="true" @handleList="handleList">
                <div class="rt-column" slot="body" slot-scope="{ item }">

                    <div class="rt-row">
                        <div class="column">
                            <span class="column-t">物品编号：</span>
                            <span class="column-c">{{ item.serialNumber || '-' }}</span>
                        </div>
                    </div>

                    <div class="rt-row">
                        <div class="column">
                            <span class="column-t">规格：</span>
                            <span class="column-c">{{ item.serialSpecifications || '-' }}</span>
                        </div>
                    </div>

                    <div class="rt-row">
                        <div class="column">
                            <span class="column-t">单位：</span>
                            <span class="column-c">
                                {{ item.unitName || '-' }}</span>
                        </div>
                    </div>
                </div>
            </PageList>
        </div>
    </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";
import Search from "@/components/search";
import PageList from "@/components/pageList";
export default {
    name: "selectItems",
    components: {
        Navbar,
        Search,
        PageList,
    },
    data() {
        return {
            appTitle: "选择物品",
            listUrl: "/jksaas-produce/produce/basicserial/basicCalculationSerical/list", //列表接口
            columns: {
                titleKey: "serialName"
            },
            keyword: "",
        };
    },
    mounted() {
        this.searchQuery();
    },
    methods: {
        handleList(id, item, type) {
            this.$router.replace({
                path: "/manHourCalculation",
                query: {
                    itemId: id,
                    itemNames: item.serialNumber + ' | ' + item.serialName + ' | ' + item.serialSpecifications
                },
            });
        },
        erpStatusFn(v) {
            if (v == 0) {
                return {
                    color: "#19BE6B",
                    bcColor: "#EAF3FC",
                };
            } else {
                return {
                    color: "#F56C6C",
                    bcColor: "#faeded",
                }
            }
        },
        // 搜索
        searchQuery(searchObj) {
            let params = {
                ...searchObj,
            };
            this.$refs.pageList.searchQuery(params);
        },
        // 查询
        onSearch(v) {
            this.keyword = v;
            let searchObj = {
                keyword: this.keyword,
            };
            this.searchQuery(searchObj);
        }
    },
};
</script>

<style lang="less" scoped>
.flex(@jc, @ai, @fd: row) {
    display: flex;
    justify-content: @jc;
    align-items: @ai;
    flex-direction: @fd;
}

.rt-column {
    padding: 20px 0 0 20px;
    //  border: 1px solid red;
}

.rt-row {
    margin-bottom: 20px;

    .column {
        width: 100%;
        display: flex;

        .column-t {
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #888888;
            // margin-bottom: 0.03rem;
        }

        .column-c {
            flex: 1;
            font-size: 28px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #191f25;
            /* （超出限定的宽度就隐藏内容) */
            overflow: hidden;
            /* （设置文字在一行显示不能换行） */
            white-space: nowrap;
            /* （规定当文本溢出时显示省略符） */
            text-overflow: ellipsis;
        }
    }
}

.search {
    position: fixed;
    top: 93px;
    z-index: 98;
    width: 100%;
}

.listBox {
    margin-top: 120px;
    // overflow-y: auto;
}

.room-content {
    height: 100vh;
    overflow-y: scroll;

    .serach {
        height: 0.33rem;
        background: #f2f2f6;
        border-radius: 0rem;
        margin-bottom: 0.16rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 0.33rem;
        padding: 0.1rem 0.12rem;

        .placeh {
            font-size: 0.16rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #888888;
            line-height: 0.23rem;
        }

        .icon {
            width: 0.15rem;
            height: 0.16rem;
        }
    }
}

.operateBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-right: 3px;
    font-size: 28px;
    font-weight: 500;
    color: #1890ff;
}

.pubBtn {
    margin-right: 20px;

    &:nth-last-child(1) {
        margin-right: 0;
    }
}

.labelLeft {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f0f6fe;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 6px 20px;
    margin-right: 10px;
    font-size: 22px;
}
</style>